import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import translate from '../../helpers/translate';
import ListProducts from './ListProducts';
import { useRecommendedMenu } from '../../hooks/useRecommended';
import Item from '../../screens/menu/list/theme2/intenList';
import DetailProduct from './DetailProduct';
import SpecialScreen from './special';
import HappyScreen from './happy';
import LiquourScreen from './liquour';
import ChangeLang from '../../components/changeLang'
import QRCode from "react-qr-code";

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
     const [showModal, setShowModal] = React.useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showLiquour, setShowLiquour] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [showHome, setShowHome] = useState(false);

    const Menu = useRecommendedMenu();

    const [dataPollo, setDataPollo] = useState(false);
    const [dataDrink, setDataDrink] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [location, setlocation] = useState('Home');
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


    useEffect(() => {
        menus.map((item) => {
        if (item.id === 39) {
            setDataPollo(item);
        }
        if (item.id === 60) {
            setDataDrink(item);
        }

        if (item.id === 42) {
            setDataDish(item);
        }
        });
    }, [menus]);


      useEffect(() => {
            const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                console.log("La página ha perdido el foco (está oculta).");
                setShowHome(false);
                setScreen('home');
                getInitData();
            } else if (document.visibilityState === "visible") {
                console.log("La página está en foco (visible).");
            }
            };
            document.addEventListener("visibilitychange", handleVisibilityChange);
    
            // Limpieza del evento al desmontar el componente
            return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            };
      }, []);
    
    
       window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };
    

    const [screen, setScreen] = useState('home');
    
 
    if (!showHome) {
        return (
            <div
                onClick={() => setShowHome(true)}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 9999,
                    backgroundColor: '#000',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
            >
                <img
                    onContextMenu={(e) => e.preventDefault()}
                    src={require('./assets/mundial.jpg')}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        pointerEvents: 'none',
                    }}
                    alt="Screensaver"
                />
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent setScreen={setScreen} setdishs={setdishs} showBack={false} showLogo={false}>
            {screen === 'home' && <>
                    <div>
                        
                         <img
                  style={{
                    width: '100%',
                    height: 141,
                    justifyContent: 'center',
                    objectFit: 'contain',
                                zIndex: -1,
                                marginTop: 10,
                    marginBottom: 10,
                  }}
                  src={require('./assets/66eb214633351.jpg')}
                        />
                        
                          <div style={{ display: 'flex',
                      alignItems: 'center',
                position: 'relative',
                marginBottom: 40,
                         
                          zIndex: 999,
                          justifyContent: 'center',}}>
                    <div onClick={()=>setShowModal('https://www.instagram.com/popocatepetlnj/')} target='_blank'> <img
                    style={{
                      width: 28,
                        height: 28,
                        marginInline: 10
                    
                  }}
                  src={require('./assets/instagram.png')}
                  alt="Logo"
                  /> 
                  </div>

                  <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/popocatepetlnj?mibextid=LQQJ4d')}> 
                    
                    
                  <img
                    style={{
                        width: 28,
                          height: 28,
                          marginInline: 10
                  }}
                  src={require('./assets/facebook.png')}
                  alt="Logo"
                  /> 
                        </div>
                         <ChangeLang/>
              
                <div>
                
                </div>
              </div>


                <div >
                    <video src={require('./assets/banner.mp4')} loop autoPlay={true} muted style={{
                        width: '100%',
                        height: 240,
                        borderRadius: 14,
                        objectFit: "contain",
                       
                    }}/>
                        </div>
                        
                        <img
                    style={{
                      width: '100%',
                        height: 28,
                                marginTop: 10,
                                objectFit: 'contain',
                    
                  }}
                  src={require('./assets/divider.png')}
                  alt="Logo"
                  /> 


                <div
                    
                    style={{
                      display:'flex',
                    flexDirection: 'row',
                        justifyContent: 'space-between',
                    marginTop: 20,
                  }}>
                    <div
                       
                    style={{width: '49%'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                      src={
                        require('./assets/offerts.png')
                      }
                    
                      style={{width: '100%', height: 220, borderRadius: 14, pointerEvents: 'none', objectFit: 'contain'}}
                    />
                            </div>
                            
                           

                    <div
                         onClick={()=>setShowHappy(true)}
                    style={{width: '49%'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                      src={require('./assets/happyhour.png')}
                     
                      style={{width: '100%', height: 220, borderRadius: 14, pointerEvents: 'none', objectFit: 'contain'}}
                    />
                            </div>
                             <div
                        onClick={()=>setShowSpecials(true)}
                    style={{width: '49%'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                      src={
                        require('./assets/specialsEN.png')
                      }
                    
                      style={{width: '100%', height: 220, borderRadius: 14, pointerEvents: 'none', objectFit: 'contain'}}
                    />
                  </div>
                        </div>
                        <img
                    style={{
                      width: '100%',
                        height: 28,
                              
                                objectFit: 'contain',
                    
                  }}
                  src={require('./assets/divider.png')}
                  alt="Logo"
                  /> 

                <div
                    onClick={()=>setShowLiquour(true)}
                 >
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                    src={require('./assets/image.png')}
                    style={{
                        width: '100%',
                        pointerEvents: 'none',
                      height: 190,
                        borderRadius: 14,
                      objectFit: 'contain',
                     
                    }}
                  />
                </div>
              
            </div>

           
            </>}

            {screen === 'listproduct' && <ListProducts
                dishs={dishs}
                setScreen={setScreen}
                    setDataDish={setDataDish}
                    setlocation={setlocation}
                setShowListProduct={setShowListProduct}
            />}

            {screen === 'detailproduct' && <DetailProduct
                dishMenu={dataDish}
                setdishs={setdishs}
                    setScreen={setScreen}
                    location={location}
                setShowDetailProduct={setShowDetailProduct}
                />}

            {showSpecials && <SpecialScreen
                setShowSpecials={setShowSpecials}
            />}

            {showHappy && <HappyScreen
                setShowSpecials={setShowHappy}
            />}
            {showLiquour && <LiquourScreen
                setShowSpecials={setShowLiquour}
                />}
                
                {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              viewBox={`0 0 256 256`}
            />
            </div>}
            </LayoutContent>
        </div>
    );
}

export default Index;